import { AgentTaskRelationshipSchema } from "@redotech/redo-model/agent-task-relationships";
import { AgentTaskSchema } from "@redotech/redo-model/agent-tasks";
import * as z from "zod/v4";

const instantiateShippingMethodsTasksOutput_ = z.object({
  tasks: z.array(AgentTaskSchema),
  relationships: z.array(AgentTaskRelationshipSchema),
});
export const InstantiateShippingMethodsTasksOutput: z.ZodType<InstantiateShippingMethodsTasksOutput> =
  instantiateShippingMethodsTasksOutput_;
export interface InstantiateShippingMethodsTasksOutput
  extends z.infer<typeof instantiateShippingMethodsTasksOutput_> {}

export const instantiateShippingMethodsTasks = {
  name: "instantiateShippingMethodsTasks" as const,
  input: z.object({ teamId: z.string() }),
  output: instantiateShippingMethodsTasksOutput_,
};
